import React from 'react';
import { LegendItem } from './LegendItem';
import { LegendContainer } from './style';
import colors from 'constants/colors';
import { OutOfServiceIcon, KingIcon, QueenIcon, KnightIcon, RookIcon, PawnIcon } from 'assets/icons';

const Legend = () => {
  return (
    <LegendContainer>
      <div className='legendRow'>
        <div className='rowLabel'>Room Status</div>
        <div className='legends'>
          <LegendItem
            backgroundColor={colors.yellow}
            legendTitle="Room Dirty"
          />
          <LegendItem
            backgroundColor={colors.lightGreen}
            legendTitle="Room Clean"
          />
          <LegendItem
            backgroundColor={colors.blue}
            legendTitle="Inspected"
          />
          <LegendItem
            iconComponent={<OutOfServiceIcon />}
            backgroundColor={colors.darkGrey}
            legendTitle="Out Of Service"
          />
          <LegendItem
            backgroundColor={colors.white}
            legendTitle="Occupied"
          />
        </div>
      </div>
      <div className='legendRow'>
        <div className='rowLabel'>Room Type</div>
        <div className='legends'>
          <LegendItem
            iconComponent={<KingIcon className="iconLayout" />}
            backgroundColor={colors.black1}
            legendTitle="King"
          />
          <LegendItem
            iconComponent={<QueenIcon className="iconLayout" />}
            backgroundColor={colors.black1}
            legendTitle="Queen"
          />
          <LegendItem
            iconComponent={<KnightIcon className="iconLayout" />}
            backgroundColor={colors.black1}
            legendTitle="Knight"
          />
          <LegendItem
            iconComponent={<RookIcon className="iconLayout" />}
            backgroundColor={colors.black1}
            legendTitle="Rook"
          />
          <LegendItem
            iconComponent={<PawnIcon className="iconLayout" />}
            backgroundColor={colors.black1}
            legendTitle="Pawn"
          />
        </div>
      </div>
    </LegendContainer>
  );
};

export default Legend;
